export default __webpack_public_path__ + "media/images/json_logo-15211ea2.svg";